export const mailingBank = 'app/mailing/MailingBank.png';
export const approved = 'app/mailing/approved.png';
export const sendingImage = 'app/mailing/sendingImage.png';
export const approveSend = 'app/mailing/approveSend.png';